module.exports = __webpack_public_path__ + "54cf98f5/img/copy-icon.408fdb2d.svg";